<template>
  <div>
    <h2>
      Pickup
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
      :rules="rules"
      :model="formData"
    >
      <el-form-item
        label="Pickup Type"
        prop="pickupType"
      >
        <el-switch v-model="formData.pickupType" />
      </el-form-item>
      <el-form-item
        label="Pickup Cutoff"
        prop="pickupCutoff"
      >
        <el-time-select
          v-model="formData.pickupCutoff"
          :picker-options="{
            start: '00:00',
            step: '01:00',
            end: '23:00'
          }"
          placeholder="Select time"
        />
      </el-form-item>
      <el-form-item
        label="Pickup Template"
        prop="pickupTemplate"
      >
        <el-input
          v-model="formData.pickupTemplate"
          placeholder="Pickup Templat"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      rules: {
        pickupType: [
          { required: true, message: 'Pickup Type is required', trigger: ['blur'] }
        ],
        pickupCutoff: [
          { required: true, message: 'Pickup Cutoff is required.', trigger: ['blur'] }
        ]
      },
      isSaving: false
    }
  }
}
</script>
